import baffle from 'baffle';
import query from "../supports/query";

export default function() {
    const revElements = query('.reveal');
    const baffledElements = revElements.map((element) => {
        const b = baffle(element, {
            characters: "abcdefghijklnopqrstuvxyz!?.:/(){}&%$',-[]",
            speed: 65        
        });
        b.start();         
        //+reveal--active?:
        observeClassChanges(element, 'reveal--active', () => {
            b.reveal(2500); 
            b.stop();
        });        
    });
}

// Funktion zum Beobachten von Klassenänderungen
function observeClassChanges(element, className, callback) {
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (element.classList.contains(className)) {
                    callback(element); // Wenn die Klasse hinzugefügt wurde, die Callback-Funktion aufrufen
                    observer.disconnect(); // Überwachung nach dem ersten Hinzufügen stoppen
                }
            }
        });
    });
    // Startet die Beobachtung des 'class'-Attributs des Elements
    observer.observe(element, { attributes: true });
}
